<template>
	<div class="storeinfo">
		<div v-if="!storeExists">
			<van-nav-bar :title="title" fixed border>
				<template #left>
					<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="onClickLeft()" />
				</template>
			</van-nav-bar>
			<div class="collapse">
				<div class="empty">
					<span class="msg">店铺已停业！</span>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="header">
				<van-nav-bar :title="title" fixed left-arrow @click-left="onClickLeft" :style="{'background-color': transparentHeader}">
					<template #left>
						<img src="../../assets/img/icon/left-arrow.png" class="icon" />
					</template>
					<template #title>
						<form action="#">
							<van-search
								v-model.trim="filterParams.words"
								shape="round"
								placeholder="请输入商品名称"
								@focus="searchFocus=true"
								@blur="searchFocus=false"
								@search="onRefresh"
								:style="{'padding':'3px 0px'}"
							>
								<template #action>
									<div @click="onRefresh">搜索</div>
								</template>
							</van-search>
						</form>
					</template>
					<template #right>
						<van-icon :name="storeInfo.favorites?'like':'like-o'" :class="storeInfo.favorites?'color_red':''" @click="resetFavotites" :style="{'margin-right':'5px'}"/>
						<van-icon name="shopping-cart-o" @click="goShoppingCart" :dot="shoppingDot" :style="{'margin-right':'5px'}"/>
						<van-icon name="share" @click="shareStore"/>
					</template>
				</van-nav-bar>
				<van-swipe :autoplay="3000">
					<van-swipe-item v-for="(image, index) in storeEnvImg" :key="index" v-if="storeEnvImg.length>0">
						<img :src="attach_url+image"/>
					</van-swipe-item>
				</van-swipe>
				<div class="info">
					<van-card
					  :title="storeInfo.s_name"
					  :thumb="storeInfo.s_img?(attach_url+storeInfo.s_img):''"
					  :tag="storeInfo.express?'可配送':''"
					>
						<template #title>
							{{storeInfo.s_name}}
							<van-button plain hairline type="danger" :style="{'height': '24px','border-radius': '5px','float': 'right'}" @click="toChat" v-if="storeInfo.u_id!=u_id"><van-icon name="chat-o" :style="{'margin-right':'3px'}"/>客服</van-button>
						</template>
						<template #desc>
							<van-notice-bar
								:text="storeInfo.s_summary"
								:scrollable="(storeInfo.s_summary&&storeInfo.s_summary.length>45)"
								color="#fff"
								background="transparent"
								:style="{padding:0,'font-size':'12px'}"
							/>
						</template>
						<template #price>
							<van-icon name="phone-o" /><a :href="'tel:' + storeInfo.s_telphone" @click.stop="">{{storeInfo.s_telphone}}</a>
						</template>
						<template #num>
							<van-icon name="location-o"  @click="showLocationByAmap(storeInfo.s_lng, storeInfo.s_lat)"/>{{storeInfo.distance|distance_format}}
						</template>
					</van-card>
				</div>
			</div>

			<van-notice-bar left-icon="volume-o" mode="closeable" v-if="storeInfo.notice">
			  {{storeInfo.notice}}
			</van-notice-bar>

			<!--van-sticky :offset-top="40" @scroll="stickyScroll">
				<van-tabs v-model="categoryActive" v-if="goodCategorys.length>0">
					<van-tab title="全部"></van-tab>
					<van-tab :title="cate.c_name" v-for="(cate, i) in goodCategorys" :key="i"></van-tab>
				</van-tabs>
			</van-sticky-->
			
			<div style="display:flex !important; ">
				<div>
					<van-sticky :offset-top="40" @scroll="stickyScroll" style="width:80px">
						<van-sidebar v-model="categoryActive" v-if="goodCategorys.length>0">
							<van-sidebar-item title="全部"></van-sidebar-item>
							<van-sidebar-item :title="cate.c_name" v-for="(cate, i) in goodCategorys" :key="i"></van-sidebar-item>
						</van-sidebar>
					</van-sticky>
				</div>

				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div
					:style="{height:(winH-190)+'px',overflow:'auto'}">
					<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="items.length==0?'暂无商品':'没有更多商品了'"
					@load="getStoreGoods"
					>
						<van-card
						  :origin-price="item.g_price_origin>0?item.g_price_origin:null"
						  :price="item.g_price"
						  :desc="item.g_note"
						  :title="item.g_name"
						  v-for="(item,index) in items"
						  :key="index"
						  :tag="item.g_day_limit>0?(item.buyed>=item.g_day_limit?'今日售罄':((item.buyed+item.buying)>=item.g_day_limit?'有机会买':'即将售罄')):''"
						  @click="viewProduct(item.g_id)"
						>
							<template #thumb>
								<div class="van-image" style="width: 100%; height: 100%;"><img :src="item.g_img?(attach_url+item.g_img):''" class="van-image__img" style="object-fit: cover;"></div>
								<div class="sale-done" v-if="item.g_stock==0">售罄</div>
							</template>
							<template #tags>
								<van-tag plain type="danger" v-if="item.g_day_limit>0">每天限售 {{item.g_day_limit}} {{goodUnitObj[item.g_unit]}}</van-tag>
								<van-tag plain type="danger" v-for="(act,aind) in item.activities" :key="'act-'+item.g_id+aind">
									{{act+(parseInt(item.singles[aind])==1?'「叠」':'')}}
								</van-tag>
							</template>
							<template #num>
								<van-icon name="cart-circle-o" size="20px" class="skin_color" @click.stop="putShoppingCart(item)"/>
							</template>
						</van-card>
					</van-list>
					</div>
				</van-pull-refresh>
			</div>

			<van-popup v-model="showAmap" position="bottom" :style="{ 'max-height': '80%'}">
				<div id="amap_container" class="amap_container"></div>
			</van-popup>

			<van-popup v-model="showShoppingGoodSku" position="bottom" :style="{ 'max-height': '80%'}">
				<van-cell-group>
					<van-cell
						:title="sku.sku_name+'：'"
						title-class="van-cell-title"
						v-for="(sku,ind) in shoppingGoodSku"
						:key="'sku_'+ind"
						>
						<template #default>
							<span 
								@click="chkGoodSku(ind, sind, sku.sku_switch)" 
								:class="{'van-sku-row__item': true}" 
								v-for="(skuo, sind) in sku.goodSkus" 
								:key="'isku_'+sind" 
								:style="{'margin':'0 0 0 5px'}"
								:ref="'ref_sku_'+ind+'_'+sind"
							>
								<div class="van-sku-row__item-name">{{skuo}}</div>
							</span>
						</template>
					</van-cell>
				</van-cell-group>
				<van-button type="primary" block @click.stop="cfmPutShoppingCart()">加入购物车</van-button>
			</van-popup>
		</div>

		<share :showShareSheet.sync="showShareSheet" :shareUrl="shareQRCodeUrl" :shareConfig="shareConfig" :botm="0" v-show="showShareSheet" v-if="initShareSheet"/>

	</div>
</template>
<script>
import { chkImgType,goodUnit,chkWeiXin } from "@/utils/common.js";
import { Sticky, List, Card, Search, Swipe, SwipeItem, Sidebar, SidebarItem} from "vant";
import Share from "@/components/Commom/Share";

export default {
	name: "Shopping",
	components: {
		"van-sticky": Sticky,
		"van-list": List,
		"van-card": Card,
		"van-search":Search,
		"van-swipe":Swipe,
		"van-swipe-item":SwipeItem,
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"share":Share
	},
	data() {
		return {
			title: "店铺信息",
			attach_url: this.Conf.serverPre,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			winH:400,
			items:[],
			cur_s_id:null,
			storeExists:true,
			storeInfo:{env_img:''},
			storeEnvImg:[],
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			filterParams:{
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
				c_id:0,
				words:'',
				order:'',
				sort:''
			},
			categoryActive:0,
			goodCategorys:[],
			goodCategoryObj:{},
			transparentHeader:'transparent',
			showAmap:false,
			amap:{},
			amapGeocoder:{},
			amapMarker:false,
			shoppingCart:{},
			shoppingDot:false,
			resetFavotitesFlag:false,
			showShoppingGoodSku:false,
			shoppingGoodInfo:{},
			shoppingGoodSku:[],
			chkGoodSkued:{},
			goodUnitObj:{},

			
			showShareSheet:false,
			shareQRCodeUrl:'',
			shareConfig:{},
			initShareSheet:false
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
		
	},
	methods: {
		// 返回
		onClickLeft() {
			this.$router.push({
				path: "/Shop"
			});
		},
		getStoreGoods() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;
				var params = this.filterParams;
				params.s_id = this.cur_s_id;
				params.page = this.page;

				var url = this.Conf.serverUrl + "Store/goods" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.loading = false;
					if (response.data.page == 1) {
						this.pageSize = response.data.pageSize;
						this.total = response.data.total;
						this.items = response.data.goods;
					}else if(response.data.goods){
						this.items = this.items.concat(response.data.goods);
					}
					if(this.page*this.pageSize >= this.total){
						this.finished = true;
					}
				})
				.catch(error => {});
			}, 1000);
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.getStoreGoods();
		},
		stickyScroll(params){
			this.transparentHeader = params.scrollTop>=20?'':'transparent !important';
		},
		putShoppingCart(g){
			if(this.storeInfo.u_id == this.u_id){
				this.$toast.fail("请移至店铺管理中操作！");
				return false
			}
			let incart = false;
			for(var i in this.shoppingCart.cart){
				if(g.g_id==this.shoppingCart.cart[i].g_id){
					incart = true;
					break;
				}
			}
			if(!incart){
				if(g.g_sku){
					this.shoppingGoodInfo = g;
					this.showShoppingGoodSku = true;
					this.shoppingGoodSku = JSON.parse(g.g_sku),
					this.chkGoodSkued = {}
				}else{
					this.shoppingCart.cart.push(g);
					this.$toast.success("已加入购物车！");
					this.shoppingDot = true;
				}
			}else{
				this.$toast.fail("您的购物车已有此商品！");
			}
		},
		cfmPutShoppingCart(){
			let seledSkuStr = "";
			let seledSku = false;
			let seledSkuVal = {};
			for(var k in this.chkGoodSkued){
				if(this.chkGoodSkued[k]){
					seledSku = true;
					var kk = k.split("_");
					if(seledSkuVal[kk[1]]){
						seledSkuVal[kk[1]].push(kk[2]);
					}else{
						seledSkuVal[kk[1]] = [kk[2]];
					}
				}
			}
			if(!seledSku){
				this.$toast.fail("请先选择商品规格！");
				return false;
			}

			for(var k in seledSkuVal){
				seledSkuStr += this.shoppingGoodSku[k].sku_name;
				seledSkuStr += '（';
				let seledSkuVals = [];
				for(var ki in seledSkuVal[k]){
					seledSkuVals.push(this.shoppingGoodSku[k].goodSkus[seledSkuVal[ki]]);
				}
				seledSkuStr += seledSkuVals.join('，');
				seledSkuStr += '）';
			}
			this.shoppingGoodInfo.g_sku_str = seledSkuStr;

			this.shoppingCart.cart.push(this.shoppingGoodInfo);
			this.$toast.success("已加入购物车！");
			this.shoppingDot = true;
			this.showShoppingGoodSku = false;
		},
		goShoppingCart(){
			this.$router.push({
				path: "/Cart"
			});
		},
		markerAmap(lnglat){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
		},
		showLocationByAmap(lng, lat){
			this.showAmap=true;

			let that = this;
			this.$nextTick(() => {
				that.amap = new AMap.Map("amap_container", {
					resizeEnable: true
				});
				that.markerAmap([lng, lat]);
			});
		},
		resetFavotites(){
			if(this.u_id && this.token){
				if(this.resetFavotitesFlag){
					this.$toast.fail("正在处理，请稍候！");
				}
				this.resetFavotitesFlag = true;
				var params = {
					f_type: 1,
					u_id: this.u_id,
					token: this.token,
					f_id: this.cur_s_id,
					o_type: this.storeInfo.favorites?'del':'add'
				};
				var url = this.Conf.serverUrl + "User/favorites" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.$toast.success(response.data.msg);
					this.resetFavotitesFlag = true;
					this.storeInfo.favorites = this.storeInfo.favorites?0:1;
				})
				.catch(error => {
					this.resetFavotitesFlag = true;
				});
			}else{
				this.$toast.fail("登录后才能收藏！");
			}
			return false;
		},
		shareStore(){
			this.showShareSheet = true;
		},
		viewProduct(g_id) {
			this.$router.push({
				path: "/Product/" + this.cur_s_id + "/" + g_id
			});
		},
		chkGoodSku(ind, sind, cswitch){
			let key = 'sku_'+ind+'_'+sind;
			if(this.chkGoodSkued[key]){
				//this.chkGoodSkued[key] = false;
				this.$refs['ref_'+key][0].className = 'van-sku-row__item';
				this.$delete(this.chkGoodSkued, key);
			}else{
				this.chkGoodSkued[key] = true;
				this.$refs['ref_'+key][0].className = 'van-sku-row__item van-sku-row__item--active';
				if(cswitch!='true'){
					for(var k in this.chkGoodSkued){
						if(k.indexOf('sku_'+ind+'_') > -1 && k!=key){
							//this.chkGoodSkued[k] = false;
							this.$refs['ref_'+k][0].className = 'van-sku-row__item';
							this.$delete(this.chkGoodSkued, k);
						}
					}
				}
			}
		},
		toChat(){
			if(this.u_id && this.token){
				this.$router.push({
					name: "Chatroom",
					query: {
						friend_id: this.storeInfo.u_id,
						friend_name: this.storeInfo.s_name,
						bottomstatus:1,
					},
				});
			}else{
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "登录后即可咨询？",
					showCancelButton:true,
					confirmButtonText:'马上登录',
					cancelButtonText:'再逛逛'
				})
				.then(() => {
					this.$router.push({
						path: "/Login"
					});
				})
				.catch(error => {});
			}
			return false;
		},
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		}
	},
	created() {
		this.getStateConfigs();
		this.goodUnitObj = goodUnit;
		this.cur_s_id = this.$route.params.s_id;
		if(!this.cur_s_id){
			this.onClickLeft();
			return false;
		}
		let isWxEnv = chkWeiXin();
		this.shareQRCodeUrl = isWxEnv?location.href:(this.Conf.clientOrigin+'/m/#/Shopping/'+this.cur_s_id);

		let storageShoppingCart = localStorage.getItem("myShoppingCart")?JSON.parse(localStorage.getItem("myShoppingCart")):{};
		this.shoppingDot = Object.keys(storageShoppingCart).length>0;
		if(!storageShoppingCart['store_'+this.cur_s_id]){
			storageShoppingCart['store_'+this.cur_s_id] = {store:{},cart:[],express:0}
		}
		this.shoppingCart = storageShoppingCart['store_'+this.cur_s_id];

		var params = {
			s_id: this.cur_s_id,
			u_id: this.u_id,
			lnglat: localStorage.getItem("lnglat")
	    };
	    var url = this.Conf.serverUrl + "Store/info" + "?num="+Math.random();
	    this.$axios
		.post(url, this.$qs.stringify(params))
		.then(response => {
			if(response.data.store){
				this.shoppingCart.store = {s_name:response.data.store.s_name,s_img:response.data.store.s_img};
				this.shoppingCart.express = response.data.store.express;
				this.storeInfo = response.data.store;
				if(this.storeInfo.env_img){
					this.storeEnvImg = this.storeInfo.env_img.split(",")
				}
				this.title = this.storeInfo.s_name;

				if(this.storeInfo.categorys){
					var cates = this.storeInfo.categorys.split(",");
					for(var i in cates){
						this.goodCategorys.push({c_id:cates[i].split(':')[0],c_name:cates[i].split(':')[1]});
						this.goodCategoryObj[cates[i].split(':')[0]] = cates[i].split(':')[1];
					}
				}

				this.shareConfig = {
					title: this.storeInfo.s_name, // 分享标题
					desc: this.storeInfo.s_summary, // 分享描述
					link: this.shareQRCodeUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: this.attach_url+this.storeInfo.s_img, // 分享图标
				}
				this.initShareSheet = true;
			}else{
				this.storeExists = false;
			}
		})
		.catch(error => {});
		this.getStoreGoods();	
	},
	watch:{
		categoryActive(){
			this.filterParams.c_id = 0;
			if(this.categoryActive>0){
				this.filterParams.c_id = this.goodCategorys[this.categoryActive-1].c_id;
			}
			this.onRefresh()
		}
	},
	beforeDestroy: function () {
		if(this.shoppingCart.cart.length > 0){
			let storageShoppingCart = localStorage.getItem("myShoppingCart")?JSON.parse(localStorage.getItem("myShoppingCart")):{}
			storageShoppingCart['store_'+this.cur_s_id] = this.shoppingCart;
			localStorage.setItem("myShoppingCart", JSON.stringify(storageShoppingCart));
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/components/Store/Index.vue